import { Component, HostListener, NgZone, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { ActivatedRoute, GuardsCheckEnd, Router } from '@angular/router';

import { MyProgram } from 'src/app/models/system/my-program.model';
import { MyProgramState } from 'src/app/selectors/system/my-program.selector';

import { getMyPrograms } from 'src/app/selectors/system/my-program.selector';
import * as myProgramActions from "src/app/actions/system/my-program.actions";
import { getLoading, OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { MyProgramConstant } from '@app/common/constant/my-program.constant';
import { Node } from '@app/models/components/node.model';
import { ValidationUtil } from '@app/common/util/validation.util';
import { PageHeadingState } from '@app/selectors/page-heading.selector';
import { setPageHeading, setShowPageHeading, setTypePageHeading } from '@app/actions/page-heading.action';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { AuthUtil } from '@app/common/util/auth.util';
import { CartState, getActionResult, getCartInfo, getCartItems, getCountCart, getIsBuyNow, getOneCartInfo, getReload, getShowAlert } from '@app/selectors/shoppingmall/cart.selector';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { OrderMstModel } from '@app/models/myoffice/order/order-mst.model';
import { ResultProc } from '@app/models/system/result-proc.model';
import { countCartInfo, loadAllCartItems, loadCartInfo, loadCartInfoNotLogin, loadCartItems, setReload } from '@app/actions/shoppingmall/cart.action';
import { ConvertUtil } from '@app/common/util/convert.util';
import { MemberModel } from '@app/models/system/member.model';
import { PageHeadingConstants } from '@app/common/constant/page-heading.constant';
import { getSmWownet, getSmWownetPg, SmWownetState } from '@app/selectors/system/sm-wownet.selector';
import { loadFindPayHeader, loadSmWownet, loadSmWownetPg, loadWowWord } from '@app/actions/system/sm-wownet.action';
import { Login2State } from '@app/selectors/system/login2.select';
import { logout } from '@app/actions/system/login2.action';
import { getWAlertStatus, WAlertState } from '@app/selectors/w-alert.selector';
import { WAlertStatus } from '@app/models/components/w-alert-stauts.model';
import { clearWAlert, setWAlert } from '@app/actions/w-alert.action';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { getPdtCates, PdtCateState } from '@app/selectors/shoppingmall/pdt-cate.selector';
import { loadPdtCate } from '@app/actions/shoppingmall/pdt-cate.action';
import { getMemberPoint, MemberPointState } from '@app/selectors/shoppingmall/member-point.selector';
import { loadMemberPoint } from '@app/actions/shoppingmall/member-point.action';
import { SmWownetPgModel } from '@app/models/system/sm-wownet-pg.model';
import { PdtCateModel } from '@app/models/shoppingmall/pdt-cate.model';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { CheckUseridConstant } from '@app/common/constant/check-userid.constant';
import { ProductState } from '@app/selectors/shoppingmall/product.selector';
import { listBrand } from '@app/actions/shoppingmall/product.action';
import { environment } from '@enviroments/environment';
import { MapCateNameOrg } from '@app/common/constant/map-cate-name-org';
import { MessageConstant } from '@app/common/constant/message.constant';
import { PrepaySearchModel } from '@app/models/myoffice/prepay/prepay-search.model';
import { getPrepayHeader, PrepayState } from '@app/selectors/myoffice/prepay/prepay.selector';
import { searchPrepayDetailsId } from '@app/actions/myoffice/prepay/prepay.action';
import { ActionConstant } from '@app/common/constant/action-constant';
import { CommonConstant } from '@app/common/constant/common.constant';
import { MemberConstants } from '@app/common/constant/member.constant';
import { PdtWishListState } from '@app/selectors/shoppingmall/wishlist-pdt-selector';
import { ParameterUtils } from '@app/common/util/parameter.util';
import { loadPdtWishList } from '@app/actions/shoppingmall/wishlist-pdt.action';

declare const backToTop: any;
declare const allMenuOpen: any;
declare const mobileMenuListener: any;
declare const mainSnbSwiper: any;
declare const modifyBackToCloseModal: any;

@Component({
  selector: 'hp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  myPrograms$ = new Observable<MyProgram[]>();

  pdtCates$ = new Observable<PdtCateModel[]>();
  pdtCates: PdtCateModel[] = [];

  cartItems$ = new Observable<OrdPdtModel[]>();

  onecartInfo$ = new Observable<OrderMstModel>();

  cartInfo$ = new Observable<OrderMstModel[]>();

  cardLength$ = new Observable<Number>();

  actionResult$ = new Observable<ResultProc>();

  onecartInfo: OrderMstModel = {} as OrderMstModel;

  cartInfo: OrderMstModel[] = {} as OrderMstModel[];

  leftmenu : MyProgram[] = [];
  rightMenu: MyProgram[] = [];
  mainMenu: MyProgram[] = [];
  subMenu: MyProgram[] = [];
  mainItems: Node<MyProgram>[] = [];
  treeMainMenu: Map<String, Node<MyProgram>> = new Map();

  alertSub$: Subscription = {} as Subscription;

  loginInfo: MemberModel | null = null;

  wAlertStatus$ = new Observable<WAlertStatus>();

  memberPoint$ = new Observable<OrderMstModel>();
  memberPoint: OrderMstModel = {} as OrderMstModel;

  prepayInfo$ = new Observable<PrepaySearchModel[]>;
  prepayInfo: PrepaySearchModel[] = [];

  smWownetPg$ = new Observable<SmWownetPgModel>();
  smWownetPg: SmWownetPgModel = {} as SmWownetPgModel;

  smWownet$ = new Observable<SmWownetModel>();
  urlWownet: string = '';

  showCartPopup: boolean = false;
  hadopen: boolean = false;
  loading: boolean = false;
  isLogined: boolean = false;
  isLoadCartItems: boolean = false;
  isBuyNow: boolean = false;
  showAlert: boolean = false;

  cardLength: number = 0;
  totalPrepay: number = 0;

  key: string = "";
  activeId: string = "";
  activeChildId: string = "";
  tempActiveId: string = "";
  activeTopLeft: string = "";
  baseUrl: string = "";
  url: string = "";
  openedId: string = "";
  ordNoTmp: string  = '';
  useridTmp: string = '';
  ordNoTmpIsNotLogin: string  = '';
  GRP_D9 = environment.comCd + MemberConstants.GRP_D9;
  GRP_AREKHAN = environment.comCd + MemberConstants.GRP_AREKHAN;
  GRP_00 = environment.comCd + MemberConstants.GRP_00;
  GRP_01 = environment.comCd + MemberConstants.GRP_01;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _loginStore: Store<Login2State>,
    private _myProgramStore: Store<MyProgramState>,
    private _cartStore: Store<CartState>,
    private _pageHeadingStore: Store<PageHeadingState>,
    private _overlayLoadingStore: Store<OverlayLoadingState>,
    private _wAlertStore: Store<WAlertState>,
    private _smWownetStateStore: Store<SmWownetState>,
    private _pdtCateStore: Store<PdtCateState>,
    private _memberPointStore: Store<MemberPointState>,
    private _productStore: Store<ProductState>,
    private _prepayStore: Store<PrepayState>,
    private _wishListStore: Store<PdtWishListState>,
    private ngZone: NgZone
  ) {
    this.myPrograms$ = this._myProgramStore.select(getMyPrograms);
    this.cartItems$ = this._cartStore.select(getCartItems);
    this.onecartInfo$ = this._cartStore.select(getOneCartInfo);
    this.cartInfo$ = this._cartStore.select(getCartInfo);
    this.cardLength$ = this._cartStore.select(getCountCart);
    this.actionResult$ = this._cartStore.select(getActionResult);
    this.wAlertStatus$ = this._wAlertStore.select(getWAlertStatus);
    this.memberPoint$ = this._memberPointStore.select(getMemberPoint);
    this.smWownetPg$ = this._smWownetStateStore.select(getSmWownetPg);
    this.pdtCates$ = this._pdtCateStore.select(getPdtCates);
    this.smWownet$ = this._smWownetStateStore.select(getSmWownet);
    this.prepayInfo$ = this._prepayStore.select(getPrepayHeader);
  }

  ngOnInit(): void {
    this._smWownetStateStore.dispatch(loadSmWownet());
    this._smWownetStateStore.dispatch(loadFindPayHeader());
    this._smWownetStateStore.dispatch(loadWowWord());
    this._smWownetStateStore.dispatch(loadSmWownetPg());
    this._pdtCateStore.dispatch(loadPdtCate({ key: "" }));
    this._productStore.dispatch(listBrand());
    this._wishListStore.dispatch(loadPdtWishList({params : ParameterUtils.getPdtWishListParams("", "", 100, 0,  "PC")}));

    this.smWownet$.subscribe(res => {
      sessionStorage.setItem(CheckUseridConstant.muserPid, res.mUsePId);
      this.urlWownet = res.urlWownet;
    });

    this._activatedRoute.queryParams.subscribe(params => {
      this.key = ConvertUtil.convertToSring(params["key"]);
    });

    this._router.events.forEach(_event => {
      if (_event instanceof GuardsCheckEnd) {
        this.initMainMenu(this.removeUrlParams(_event.url));
        setTimeout(() => {
          if (typeof backToTop === "function") {
            backToTop();
          }
        }, 200);
        setTimeout(() => {
          mobileMenuListener();
        }, 500);
      }

    });

    this.alertSub$ = this.wAlertStatus$.subscribe(res => {
      this.handleActionConfirm(res);
    });

    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._myProgramStore.dispatch(myProgramActions.loadMyPrograms());

    this.myPrograms$.subscribe(res => {
      this.leftmenu = res.filter(y => y.prgKind == MyProgramConstant.kindMenuTopLeft);
      this.rightMenu = res.filter(y => y.prgKind == MyProgramConstant.kindMenuTopRight);
      this.mainMenu = res.filter(
        y => y.prgKind == MyProgramConstant.kindMenuHome
          || y.prgKind == MyProgramConstant.kindMenuOffice
          || y.prgKind == MyProgramConstant.kindMenuShopping
      );

      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
      this.initMainMenu(window.location.pathname);

      setTimeout(() => {
        mainSnbSwiper();
      }, 500);
      mobileMenuListener();
    });

    this.pdtCates$.subscribe(res => {
      if(AuthUtil.getLoginedInfo() && (AuthUtil.getLoginedInfo()?.userKindCd == 'U40' || AuthUtil.getLoginedInfo()?.userKindCd == 'U50')) {
        this.pdtCates = res;
      } else {
        this.pdtCates = res.filter( y => y.cateCd != environment.comCd + '95')
      }  
    });

    this.smWownetPg$.subscribe(res => this.smWownetPg = res);

    this.actionResult$.subscribe(res => {
      if (res.retCode === "OK") {
        if (this.isBuyNow) {
          this.ordNoTmpIsNotLogin = ConvertUtil.convertToSring(res.keyValue);
          this._router.navigateByUrl(MyProgramConstant.urlShopping + `/checkout?ordNoTmp=${res.keyValue}`);
        } else {
          if (this.showAlert) {
            if(ValidationUtil.isNotNullAndNotEmpty(res.keyValue)){
              this._wAlertStore.dispatch(setWAlert({
                wAlert: {
                  icon: WAlertConstant.successful,
                  confirmBtnText: '계속쇼핑',
                  cancelBtnText: '장바구니',
                  action: 'add_cart_confirm',
                  message: ConvertUtil.convertToSring(res.retStr)
                }
              }));

            } else {
              this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.successful, message: ConvertUtil.convertToSring(res.retStr)}}));
            }

          }
        }
        this.loadCart();
      } else if (ValidationUtil.isNotNullAndNotEmpty(res.retStr)) {
        this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.cancelled, message: ConvertUtil.convertToSring(res.retStr)}}));
      }
      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
    });

    this._overlayLoadingStore.select(getLoading).subscribe(res => this.loading = res);
    this._cartStore.select(getIsBuyNow).subscribe(res => this.isBuyNow = res);
    this._cartStore.select(getShowAlert).subscribe(res => this.showAlert = res);
    this._cartStore.select(getReload).subscribe(res => {
      if (res) {
        this.loadCart();
        this._cartStore.dispatch(setReload({ reload: false }));
      }
    });

    this.loadCart();

    this._cartStore.dispatch(countCartInfo({ userid: ConvertUtil.convertToSring(AuthUtil.getLoginedInfo()?.userid)}));

    this.cardLength$.subscribe(res => {
      this.cardLength = Number(res);
    });
    this.cartInfo$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
      this.cartInfo = res;
      }
    });

    this.onecartInfo$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.onecartInfo = res;
      }
    });

    this._memberPointStore.dispatch(loadMemberPoint({ userid: ConvertUtil.convertToSring(AuthUtil.getLoginedInfo()?.userid) }));
    this.memberPoint$.subscribe(res => this.memberPoint = res);

    this._prepayStore.dispatch(searchPrepayDetailsId({ userid: ConvertUtil.convertToSring(AuthUtil.getLoginedInfo()?.userid) }));
    this.prepayInfo$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.prepayInfo = res;
        let tmp = 0;
        for(let i=0; i<res.length; i++){
          tmp = tmp + +res[i].amtbalance;
        }

        this.totalPrepay = tmp;
      }
    });
  }

  loadMainMenu(): void {
    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this.subMenu = [];

    this.changeTitlePage("Purple U Shop");

    let kind = MyProgramConstant.kindMenuShopping;
    if (this.baseUrl === MyProgramConstant.urlMyOffice) {
      kind = MyProgramConstant.kindMenuOffice;
      this.activeTopLeft = MyProgramConstant.officeId;
      this._pageHeadingStore.dispatch(setTypePageHeading({ payload: PageHeadingConstants.typeOP }));
    } else if (this.baseUrl === '/company' || this.baseUrl === '/business' || this.baseUrl === '/brand' || this.baseUrl === '/communication') {
      kind = MyProgramConstant.kindMenuHome;
      this.activeTopLeft = MyProgramConstant.homeId;
      this._pageHeadingStore.dispatch(setTypePageHeading({ payload: PageHeadingConstants.typeHP }));
    } else /*if (this.baseUrl === MyProgramConstant.urlShopping)*/ {
      // kind = MyProgramConstant.kindMenuShopping;
      this.activeTopLeft = MyProgramConstant.shoppingId;
    //   this._pageHeadingStore.dispatch(setTypePageHeading({ payload: PageHeadingConstants.typeHP }));
    // } else {
    //   this.activeTopLeft = MyProgramConstant.homeId;
      if (this.url == "/") {
        this._pageHeadingStore.dispatch(setTypePageHeading({ payload: PageHeadingConstants.typeSP }));
      } else {
        this._pageHeadingStore.dispatch(setTypePageHeading({ payload: PageHeadingConstants.typeHP }));
      }
    }

    this.treeMainMenu = new Map();
    this.loadMainMyOfficeAndHomeMainMenu(this.mainMenu, kind);
    this.mainItems = Array.from(this.treeMainMenu.values());

    this.setActiveId();

    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
  }

  setDataTreeMainMenu(item: MyProgram): void {
    if (item.menuLv == '1') {
      this.treeMainMenu.set(item.prgId, { data: item, children: [] });
    } else if (item.menuLv == '2') {

      const node = this.treeMainMenu.get(item.pid);
      if (node?.children !== undefined && node?.children !== null) {
        node.children.push({ data: item, children: [] });
      }
      this.subMenu.push(item);
    }
  }

  loadMainMyOfficeAndHomeMainMenu(items: MyProgram[], kind: string): void {
    this.tempActiveId = "";
    let item: MyProgram;
    for (let i = 0; i < items.length; i++) {
      item = items[i];
      if (item.prgKind == kind) {
        this.setDataTreeMainMenu(item);
      }
      if (item.menuLv == "1" && item.linkInfo === this.url) {
        this.tempActiveId = item.prgId;
      }
      this.updateTitleByUrl(item);
    }
  }

  setActiveId(): void {
    let havePageHeading = false;
    this.activeId = "";
    this.activeChildId = "";
    if (ValidationUtil.isNotNullAndNotEmpty(this.subMenu)) {

      for (const item of this.subMenu) {
        if (item.linkInfo === this.url && (item.prgKind === MyProgramConstant.kindMenuOffice || item.prgKind === MyProgramConstant.kindMenuHome)) {
          this.activeId = item.pid;
          this.activeChildId = item.prgId;
          const node = this.treeMainMenu.get(this.activeId);
          if (node !== undefined && node !== null) {
            havePageHeading = true;
            this._pageHeadingStore.dispatch(setPageHeading({ node: node, child: item, pathname: this.url }));
          }
        }
      }
    }
    if (!havePageHeading) {
      if (PageHeadingConstants.MAP_LINK_W_LEFT_MENU.has(this.url)) {
        let menuName = PageHeadingConstants.MAP_LINK_W_LEFT_MENU.get(this.url)
        for (const item of this.subMenu) {
          if (item.linkInfo === menuName) {
            const node = this.treeMainMenu.get(item.pid);
            if (node !== undefined && node !== null) {
              this._pageHeadingStore.dispatch(setPageHeading({ node: node, child: item, pathname: item.linkInfo }));
            }
          }
        }
      }/*else if(CategoryConstants.MAP_SORTCD.has(this.url)){

        this.activeId = ConvertUtil.convertToSring(CategoryConstants.MAP_SORTCD.get(this.url));
      }*/else{
        this._pageHeadingStore.dispatch(setShowPageHeading({ show: false }));
      }
    }
    if (ValidationUtil.isNullOrEmpty(this.activeId) && ValidationUtil.isNullOrEmpty(this.activeChildId) && ValidationUtil.isNotNullAndNotEmpty(this.tempActiveId)) {
      this.activeId = this.tempActiveId;
    }
  }

  initMainMenu(url: string): void {
    if (AuthUtil.isLogined()) {
      this.isLogined = true;
    } else {
      this.isLogined = false;
    }

    let tm = setInterval(() => {
      this.loginInfo = AuthUtil.getLoginedInfo();
      if (this.loginInfo) {
        clearInterval(tm);
      }
    }, 100);

    let tempUrl: string[] = [];

    this.url = url;
    tempUrl = this.url.split("/");
    if (tempUrl.length >= 2) {
      this.baseUrl = "/" + tempUrl[1];
    }

    this.loadMainMenu();
  }

  handleOnClickRightMenu(item: MyProgram): void {
    if (item.linkInfo == '/logout') {
      this._loginStore.dispatch(logout());
      localStorage.removeItem('member');
      localStorage.removeItem('lastAction');
      sessionStorage.removeItem(CommonConstant.LINK_CART);
      sessionStorage.removeItem(CommonConstant.LINK_CART_PRODUCTS);
      sessionStorage.removeItem(CommonConstant.CART_INFO_TMP);
      location.href = "/";
    } else {
      this._router.navigate([item.linkInfo]);
    }
  }

  handleOnSearch(): void {
    if (ValidationUtil.isNotNullAndNotEmpty(this.key)) {
      this._router.navigateByUrl(MyProgramConstant.urlShopping + `/product-search?key=${this.key}`);
    } else {
      this._router.navigate([MyProgramConstant.urlShopping]);
    }
  }

  loadCart(): void {
    this._activatedRoute.queryParamMap.subscribe(params => {
      this.ordNoTmp = ConvertUtil.convertToSring(params.get("ordNoTmp"))
      this.useridTmp = ConvertUtil.convertToSring(params.get("userid"))
    });

    if (AuthUtil.isLogined()) {
      let member = AuthUtil.getLoginedInfo();

      if (member) {
        this._cartStore.dispatch(loadCartInfo({ userid: ConvertUtil.convertToSring(member.userid), ctrCd: ConvertUtil.convertToSring(member.ctrCd), page: Number(0), len: Number(100)}));
        this._cartStore.dispatch(countCartInfo({ userid: ConvertUtil.convertToSring(member.userid)}));
        this._cartStore.dispatch(loadCartItems({ userid: ConvertUtil.convertToSring(member.userid), ordNoTmp: this.ordNoTmp }));
        this._cartStore.dispatch(loadAllCartItems({ userid: ConvertUtil.convertToSring(member.userid)}))
      }
    } else {

      let consumer = AuthUtil.getInfoUserId2();
      let linkCart: any = sessionStorage.getItem(CommonConstant.LINK_CART);

      if(ValidationUtil.isNotNullAndNotEmpty(this.useridTmp)) {
        this._cartStore.dispatch(loadCartInfoNotLogin({ordNoTmp: +this.ordNoTmp}));
        this._cartStore.dispatch(loadCartItems({ userid: this.useridTmp, ordNoTmp: this.ordNoTmp }));
      } else if(ValidationUtil.isNotNullAndNotEmpty(linkCart)) {
        linkCart = JSON.parse(linkCart);

        this._cartStore.dispatch(loadCartInfoNotLogin({ordNoTmp: +linkCart.ordNoTmp}));
        this._cartStore.dispatch(loadCartItems({ userid: linkCart.userid, ordNoTmp: linkCart.ordNoTmp }));
      } else {
        let userid = '';
        if (consumer) {
          userid = ConvertUtil.convertToSring(consumer.userid);
        } else {
          userid = environment.comCd + "00000000";
        }
        window.dispatchEvent(new Event('storage'));
        this._cartStore.dispatch(loadCartInfo({ userid: userid, ctrCd: environment.default_lang , page: Number(0), len: Number(100)}));
        this._cartStore.dispatch(loadCartItems({ userid: userid, ordNoTmp: this.ordNoTmpIsNotLogin }));
        this._cartStore.dispatch(countCartInfo({ userid: userid}));
      }
    }
  }

  removeUrlParams(url: string): string {
    if (ValidationUtil.isNotNullAndNotEmpty(url)) {
      return url.split("?")[0];
    }
    return location.pathname;
  }

  updateTitleByUrl(item: MyProgram): void {
    if (item.linkInfo === this.url) {
      this.changeTitlePage("Purple U Shop | " + item.prgName);
    }
  }

  changeTitlePage(title: string): void {
    var _title = document.querySelector("title");
    if (_title) {
      _title.innerText = title;
    }
  }

  handleClickToCart() {
    if (AuthUtil.isLogined()) {
      this._router.navigateByUrl(MyProgramConstant.urlShopping + `/page-list-cart`);
    } else {
      this._router.navigateByUrl( MyProgramConstant.urlShopping + `/cart`);
    }
  }

  handleOnclickShopping(sort: string, item: any) {
    type QueryParams = {
      sort? : string,
      cate? : string
    }

    let prefix = '';
    let cate = '';
    let tmp = [];

    if(sort == '/') {
      sort = 'All';
    }

    let vmap = MapCateNameOrg.MAP_CATENAME.get(sort);
    if(ValidationUtil.isNotNullAndNotEmpty(vmap)) {
      if(!ValidationUtil.isNotNullAndNotEmpty(item)) {
        tmp = this.pdtCates.filter(x => {
          return x.cateNameOrg == vmap;
        });

        cate = ConvertUtil.convertToSring(tmp[0].cateCd);
      } else {
        this.hadopen = !this.hadopen;
        allMenuOpen();
        cate = item.cateCd;
      }
    } else {
      cate = '*';
    }

    var params : QueryParams = {sort: sort};
    if(cate == '*') {
      prefix = `?sort=${sort}`;
    } else {
      prefix = `?sort=${sort}&cate=${cate}`;
      params.cate = cate;
    }

    if (AuthUtil.isLogined()) {
      if(sort == 'Joint') {
        let jointMenu = this.mainMenu.filter(x=> x.prgKind == 'ms' && x.menuLv == '2' && x.pid == "ms.Shop.Joint-purchase");
        this._router.navigateByUrl(jointMenu[0].linkInfo + prefix);
      } else if(sort == 'Promotion') {
        let promotionMenu = this.mainMenu.filter(x=> x.prgKind == 'ms' && x.menuLv == '2' && x.pid == "ms.Shop.Promotion");
        this._router.navigateByUrl(promotionMenu[0].linkInfo + prefix);
      } else if (sort == 'Subscription') {
        this._router.navigateByUrl(MyProgramConstant.urlMyOffice + '/auto-ship/register');
      } else {
        this._router.navigateByUrl("/", {skipLocationChange: true})
                    .then(() => this._router.navigate([MyProgramConstant.urlShopping], {queryParams: params, queryParamsHandling: 'merge'}));
      }
    } else {
      if(sort == 'Point' || sort == 'Joint' || sort == 'Subscription' || sort == 'Promotion') {
        this.showAlertRequiredLogined();
      } else {
        this._router.navigateByUrl("/", {skipLocationChange: true})
                    .then(() => this._router.navigate([MyProgramConstant.urlShopping], {queryParams: params, queryParamsHandling: 'merge'}));
        // this._router.navigateByUrl(MyProgramConstant.urlShopping + prefix);
      }
    }
  }

  handleCLickAllMenu() {
    this.hadopen = !this.hadopen;
    allMenuOpen();
  }

  showAlertRequiredLogined(): void {
    this._wAlertStore.dispatch(
      setWAlert({
        wAlert: {
          icon: WAlertConstant.confirm,
          message: MessageConstant.msgRequiredLogin,
          action: ActionConstant.actionConfirmLogined
        }
      })
    );
  }

  handleOnclickMyoffice(linkInfo: any) {
    this.hadopen = !this.hadopen;
    allMenuOpen();
    this._router.navigate([linkInfo]);
  }

  handleOnClickToggleCartPopup(show: boolean): void {
    this.showCartPopup = show;
  }

  handleOnClickShowAllCart(): void {
    modifyBackToCloseModal();
    this.showCartPopup = true
  }

  handleActionConfirm(status: WAlertStatus): void {
    if (status.action === ActionConstant.actionConfirmLogined && status.isConfirm) {
      this._wAlertStore.dispatch(clearWAlert());
      this._router.navigate(["/login"]);
    }

    if(status.action === ActionConstant.actionConfirmAddCart && status.isConfirm) {
      this._wAlertStore.dispatch(clearWAlert());
      this.handleOnClickShowAllCart();
    }
  }

  @HostListener('window:storage')
  onConsumerStorageChange() {
    let userId = sessionStorage.getItem(CommonConstant.USER_ID);
    if((ValidationUtil.isNullOrEmpty(userId) || userId == "null")) {
      sessionStorage.setItem(CommonConstant.LINK_GUEST, CommonConstant.NO);
      sessionStorage.removeItem(CommonConstant.CONSUMER);
      //sessionStorage.removeItem(CommonConstant.CART_INFO_TMP);
    }
  }

  onClickRegisterCloneMember(item: MyProgram) {
    sessionStorage.setItem(MemberConstants.STR_IS_DONE_STEP_CHOOSE_REGISTER, "true");
    sessionStorage.setItem(MemberConstants.STR_IS_DONE_STEP_1, "true");
    this._router.navigateByUrl(item.linkInfo);
  }

}

